<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:23
-->
<template>
	<el-drawer
		:visible.sync="visible"
		:append-to-body="appendToBody"
		size="1100px"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		custom-class="drawer-template"
	>
		<div slot="title">
			<span>推广审核</span>
		</div>
		<div>
			<el-table :data="list" class="table-small" v-loading="loading">
				<el-table-column label="发起审核时间" width="155px">
					<template slot-scope="{ row }">
						<rd-text :value="row.applyTime"></rd-text>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="310px">
					<template slot-scope="{ row }">
						<div class="flex-row pl-12 pr-8">
							<div>
								<rd-img class="flex-center" imgType="good" :src="row.product.productPic" :size="60" />
							</div>
							<div class="ml-8">
								<div class="flex-row-align-center">
									<platform-icon :platformId="row.product.platform_id" style="flex-shrink: 0"></platform-icon>
									<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.product.productName">
										<span
											class="ml-4 yx-color-text-primary font-h6-medium line-ellipsis-1 cursor-pointer hover"
											style="max-width: 150px"
											@click="skipFun"
										>
											{{ row.product.productName }}
										</span>
									</el-tooltip>
									<ID-tag label="商品ID" :id="row.product.outerProductId" />
								</div>
								<div class="font-h6-regular yx-color-text-secondary">
									<span>日常价</span>
									<span class="ml-2">{{ row.product.salePrice | formatEmpty | formatPrice3 | formatPrice2 | formatPrice }}</span>
									<span class="ml-6">销量</span>
									<span class="ml-2">{{ row.product.sales | formatEmpty | formatPrice2 }}</span>
								</div>
								<div class="font-h6-regular yx-color-text-secondary flex-row-align-center">
									<span>普通佣金率</span>
									<span class="ml-2">{{ row.product.commissionRate | formatEmpty | formatPercent2 }}</span>
									<span class="ml-6">库存</span>
									<span class="ml-2">{{ row.product.stockNum | formatEmpty | formatPrice2 }}</span>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="报名机制" prop="partner_commission_fee" width="140px">
					<template slot-scope="{ row }">
						<div class="yx-color-text-primary font-h6-regular">
							<span>服务费率</span>
							<span class="ml-6">{{ row.serviceFeeRate | formatEmpty | formatPercent2 }}</span>
						</div>
						<div class="yx-color-text-primary font-h6-regular">
							<span>达人佣金率</span>
							<span class="ml-6">{{ row.talentCommission | formatEmpty | formatPercent2 }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="类型" prop="partner_commission_fee" width="80PX">
					<template slot-scope="{ row }">
						<rd-status :statusType="'warning'" class="cursor-pointer">待审核</rd-status>
					</template>
				</el-table-column>
				<el-table-column label="申请团长" prop="partner_commission_fee" width="115px">
					<template slot-scope="{ row }">
						<rd-text>{{ row.authorityName }}</rd-text>
						<rd-text label="ID" :value="row.authorityId"></rd-text>
					</template>
				</el-table-column>
				<el-table-column label="团长联系人" prop="partner_commission_fee" width="150px">
					<template slot-scope="{ row }">
						<rd-text>{{ row.contact.userName }}</rd-text>
						<rd-text label="电话" :value="row.contact.userMobile"></rd-text>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="80px" fixed="right" prop="operates">
					<template slot-scope="{ row }">
						<div class="flex-row-align-center">
							<el-button class="fz-12" type="text" @click="pass(row)">通过</el-button>
							<el-button class="fz-12" type="text" @click="refuse(row)">拒绝</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="page.page_index"
				:page-size="page.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			></yx-pagination>
		</div>
		<div class="drawer-footer yx-background-white" style="z-index: 999">
			<el-button @click="handleClose">我知道了</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { debounce } from 'lodash';
import IDTag from '@/components/ui/IDTag';
import { applyAuditList, applyPuditFail, applyPuditPass } from '@/api/secondColonelManage';
export default {
	components: {
		IDTag,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			page: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			loading: false, // 表格加载状态
			btnLoading: false, // 按钮loading
			size: 'default',
			wrapperClosable: false,
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show() {
			this.visible = true;
			this.getList();
		},
		// 获取表格列表数据
		async getList() {
			const { platformId } = this;
			// 列表loading状态开启
			this.loading = true;
			try {
				const { list = [], page = {} } = await applyAuditList({ ...this.page, platformId });
				this.list = list;
				this.total = `${page.item_total}`;
			} catch (error) {
				this.list = [];
				this.total = 0;
			} finally {
				// 列表loading状态关闭
				this.loading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.page = {
				page_index: 1,
				page_size: 20,
			};
			this.loading = false;
			this.btnLoading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			// 按钮loading开启
			this.btnLoading = true;
			try {
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading开启
				this.btnLoading = false;
			}
		}, 300),
		// 每页展示条数变化
		sizeChange(val) {
			this.page.page_size = val;
			this.page.page_index = 1;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.page.page_index = val;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 抽屉尺寸，small:500px，default: 600px，normal:800px，large:1080px
			this.size = 'default';
			// 表单标签长度
			this.labelWidth = '100px';
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		pass({ applyId }) {
			this.$modal({
				title: '确认审核通过？',
				contentTitle: '审核通过后，商品将根据自动报名团长指定的招商活动',
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: '确认审核通过',
						key: 'confirm',
					},
				],
			}).then(async res => {
				if (res.key == 'confirm') {
					await applyPuditPass({ id: applyId });
					this.$message.success('操作成功！');
					this.$emit('refresh');
					this.getList();
					res.done();
				} else {
					res.done();
				}
			});
		},
		refuse({ applyId }) {
			this.$modal({
				title: '确认审核拒绝？',
				contentTitle: '审核拒绝后，需要团长在商品公海重新提交审核',
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: '确认审核拒绝',
						key: 'confirm',
					},
				],
			}).then(async res => {
				if (res.key == 'confirm') {
					await applyPuditFail({ id: applyId });
					this.$message.success('操作成功！');
					this.getList();
					this.$emit('refresh');
					res.done();
				} else {
					res.done();
				}
			});
		},
		async skipFun({ product }) {
			window.open(product.productUrl, '_blank');
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.table-small {
	::v-deep thead th {
		font-weight: 600 !important;
	}
}
</style>